(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-ascolta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(t) { if (!isFinite(t)) return '0:00'; var m = Math.floor(t / 60), s = Math.floor(t % 60); return m + ':' + (s < 10 ? '0' : '') + s; }
  function player(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var a = root.querySelector('audio'), btn = root.querySelector('[data-nx-play]'), fill = root.querySelector('[data-nx-fill]');
    var bar = root.querySelector('[data-nx-seek]'), cur = root.querySelector('[data-nx-cur]'), dur = root.querySelector('[data-nx-dur]');
    btn.addEventListener('click', function () {
      if (a.paused) {
        document.querySelectorAll('video, audio').forEach(function (m) { if (m !== a && !m.paused) m.pause(); });
        var p = a.play(); if (p && p.catch) p.catch(function () {});
      } else a.pause();
    });
    a.addEventListener('play', function () { root.classList.add('is-playing'); });
    a.addEventListener('pause', function () { root.classList.remove('is-playing'); });
    a.addEventListener('ended', function () { root.classList.remove('is-playing'); });
    a.addEventListener('loadedmetadata', function () { dur.textContent = fmt(a.duration); });
    a.addEventListener('timeupdate', function () {
      var pct = a.duration ? a.currentTime / a.duration * 100 : 0;
      fill.style.width = pct + '%'; cur.textContent = fmt(a.currentTime); bar.setAttribute('aria-valuenow', Math.round(pct));
    });
    function seek(x) { var r = bar.getBoundingClientRect(); if (a.duration) a.currentTime = Math.max(0, Math.min(1, (x - r.left) / r.width)) * a.duration; }
    bar.addEventListener('click', function (e) { seek(e.clientX); });
    bar.addEventListener('keydown', function (e) {
      if (!a.duration) return;
      if (e.key === 'ArrowRight') a.currentTime = Math.min(a.duration, a.currentTime + 5);
      if (e.key === 'ArrowLeft') a.currentTime = Math.max(0, a.currentTime - 5);
    });
    document.addEventListener('play', function (e) { if (e.target !== a && e.target.tagName === 'VIDEO') a.pause(); }, true);
  }
  function init(scope) { (scope || document).querySelectorAll('[data-nx-player]').forEach(player); if (window.nxReveal) window.nxReveal(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-nx-faq]').forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';
      list.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName !== 'DETAILS' || !d.open) return;
        list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    });
    if (window.nxReveal) window.nxReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function vsl(root) {
    var btn = root.querySelector('[data-nx-vsl-play]');
    var tpl = root.querySelector('[data-nx-vsl-video]');
    if (!btn || !tpl || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.addEventListener('click', function () {
      var frag = tpl.content.cloneNode(true);
      var v = frag.querySelector('video');
      btn.replaceWith(frag);
      if (v) { v.setAttribute('autoplay', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function net(c) {
    if (c.dataset.ready) return;
    c.dataset.ready = '1';
    var ctx = c.getContext('2d');
    if (!ctx) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 0, H = 0, pts = [], edges = [], rot = 0, tx = 0, ty = 0, mx = 0, my = 0, raf = 0, on = false;

    function seed() {
      var n = W < 750 ? 64 : 132;
      pts = []; edges = [];
      for (var i = 0; i < n; i++) {
        var u = Math.random() * 2 - 1, t = Math.random() * Math.PI * 2, r = 0.72 + Math.random() * 0.38, s = Math.sqrt(1 - u * u);
        pts.push([r * s * Math.cos(t), r * u * 0.78, r * s * Math.sin(t)]);
      }
      for (i = 0; i < n; i++) for (var j = i + 1; j < n; j++) {
        var dx = pts[i][0] - pts[j][0], dy = pts[i][1] - pts[j][1], dz = pts[i][2] - pts[j][2];
        if (dx * dx + dy * dy + dz * dz < 0.17) edges.push([i, j]);
      }
    }
    function size() {
      var d = Math.min(window.devicePixelRatio || 1, 1.5);
      W = c.clientWidth; H = c.clientHeight;
      c.width = W * d; c.height = H * d;
      ctx.setTransform(d, 0, 0, d, 0, 0);
      seed();
    }
    function draw() {
      rot += 0.0011; tx += (mx - tx) * 0.04; ty += (my - ty) * 0.04;
      var ay = rot + tx * 0.5, ax = 0.28 + ty * 0.3;
      var cy = Math.cos(ay), sy = Math.sin(ay), cx = Math.cos(ax), sx = Math.sin(ax);
      var R = Math.max(W * 0.46, H * 0.42), F = 2.6, P = [];
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], x = p[0] * cy - p[2] * sy, z = p[0] * sy + p[2] * cy, y = p[1] * cx - z * sx;
        z = p[1] * sx + z * cx;
        var k = F / (F + z);
        P.push([W / 2 + x * R * k, H * 0.46 + y * R * k, z]);
      }
      ctx.clearRect(0, 0, W, H);
      ctx.lineWidth = 1;
      for (i = 0; i < edges.length; i++) {
        var a = P[edges[i][0]], b = P[edges[i][1]];
        var depth = 1 - ((a[2] + b[2]) / 2 + 1.1) / 2.2;
        ctx.strokeStyle = 'rgba(136,97,252,' + (0.06 + depth * 0.3).toFixed(3) + ')';
        ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
      }
      for (i = 0; i < P.length; i++) {
        var q = P[i], dd = 1 - (q[2] + 1.1) / 2.2;
        ctx.fillStyle = 'rgba(185,163,255,' + (0.25 + dd * 0.65).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(q[0], q[1], 0.8 + dd * 1.8, 0, 6.2832); ctx.fill();
      }
    }
    function loop() { draw(); raf = on ? requestAnimationFrame(loop) : 0; }
    function start() { if (on || reduce) return; on = true; raf = requestAnimationFrame(loop); }
    function stop() { on = false; if (raf) cancelAnimationFrame(raf); raf = 0; }

    size(); draw();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }).observe(c);
    } else { start(); }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { size(); draw(); }, 200); });
    window.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nx-vsl]').forEach(vsl);
    (scope || document).querySelectorAll('[data-nx-net]').forEach(net);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-impari"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tilt(el) {
    if (el.dataset.tiltReady || window.matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches) return;
    el.dataset.tiltReady = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--rx', (-y * 4).toFixed(2) + 'deg');
      el.style.setProperty('--ry', (x * 5).toFixed(2) + 'deg');
    });
    el.addEventListener('pointerleave', function () {
      el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
    });
  }
  function count(el) {
    if (el.dataset.countReady) return;
    el.dataset.countReady = '1';
    var target = parseInt(el.getAttribute('data-nx-count'), 10) || 0;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = target; return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = 900;
        function step(t) {
          var p = Math.min((t - t0) / dur, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    io.observe(el);
  }
  function init(scope) {
    (scope || document).querySelectorAll('.nx-imp').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      root.querySelectorAll('[data-nx-tilt]').forEach(tilt);
      root.querySelectorAll('[data-nx-count]').forEach(count);
      var grid = root.querySelector('[data-nx-grid]'), btn = root.querySelector('[data-nx-more]');
      if (grid && btn && grid.children.length > 4) {
        btn.hidden = false; btn.classList.add('is-shown');
        btn.addEventListener('click', function () {
          grid.classList.add('is-open');
          grid.querySelectorAll('[data-nx-reveal]').forEach(function (el) { el.classList.add('is-in'); });
          btn.remove();
        });
      }
    });
    if (window.nxReveal) window.nxReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-metodo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COLORS = { green: [22, 239, 18], cyan: [45, 226, 230], purple: [139, 98, 255] };
  function brain(c) {
    if (c.dataset.ready) return;
    c.dataset.ready = '1';
    var ctx = c.getContext('2d'); if (!ctx) return;
    var col = COLORS[c.dataset.color] || COLORS.purple;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W, H, pts = [], edges = [], rot = Math.random() * 6, on = false, raf = 0;
    for (var i = 0; i < 90; i++) {
      var u = Math.random() * 2 - 1, t = Math.random() * 6.2832, r = 0.8 + Math.random() * 0.25, s = Math.sqrt(1 - u * u);
      var x = r * s * Math.cos(t) * 1.15, y = r * u * 0.82, z = r * s * Math.sin(t);
      if (Math.abs(x) < 0.07) x += x < 0 ? -0.08 : 0.08;
      pts.push([x, y, z]);
    }
    for (i = 0; i < pts.length; i++) for (var j = i + 1; j < pts.length; j++) {
      var dx = pts[i][0] - pts[j][0], dy = pts[i][1] - pts[j][1], dz = pts[i][2] - pts[j][2];
      if (dx * dx + dy * dy + dz * dz < 0.2 && (pts[i][0] > 0) === (pts[j][0] > 0)) edges.push([i, j]);
    }
    function size() { var d = Math.min(window.devicePixelRatio || 1, 2); W = c.clientWidth; H = c.clientHeight; c.width = W * d; c.height = H * d; ctx.setTransform(d, 0, 0, d, 0, 0); }
    function draw() {
      rot += 0.006;
      var cy = Math.cos(rot), sy = Math.sin(rot), R = Math.min(W, H) * 0.36, P = [];
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], x = p[0] * cy - p[2] * sy, z = p[0] * sy + p[2] * cy, y = p[1] - z * 0.18;
        var k = 2.6 / (2.6 + z);
        P.push([W / 2 + x * R * k, H / 2 + y * R * k, z]);
      }
      ctx.clearRect(0, 0, W, H);
      var g = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, R * 1.4);
      g.addColorStop(0, 'rgba(' + col + ',0.28)'); g.addColorStop(1, 'rgba(' + col + ',0)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      for (i = 0; i < edges.length; i++) {
        var a = P[edges[i][0]], b = P[edges[i][1]], dd = 1 - ((a[2] + b[2]) / 2 + 1.1) / 2.2;
        ctx.strokeStyle = 'rgba(' + col + ',' + (0.12 + dd * 0.5).toFixed(3) + ')';
        ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
      }
      for (i = 0; i < P.length; i++) {
        var q = P[i], e = 1 - (q[2] + 1.1) / 2.2;
        ctx.fillStyle = 'rgba(' + col + ',' + (0.4 + e * 0.6).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(q[0], q[1], 0.9 + e * 1.6, 0, 6.2832); ctx.fill();
      }
    }
    function loop() { draw(); raf = on ? requestAnimationFrame(loop) : 0; }
    size(); draw();
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { if (!on) { on = true; raf = requestAnimationFrame(loop); } }
        else { on = false; if (raf) cancelAnimationFrame(raf); }
      }).observe(c);
    }
    window.addEventListener('resize', function () { size(); draw(); });
  }
  function init(scope) { (scope || document).querySelectorAll('[data-nx-brain]').forEach(brain); if (window.nxReveal) window.nxReveal(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  (function () {
    function consentOk(a) {
      var check = document.querySelector('[data-nx-consent-check]');
      if (!check || check.checked) return true;
      var err = document.querySelector('[data-nx-consent-error]');
      var box = document.querySelector('[data-nx-consent]');
      if (err) err.hidden = false;
      if (box) { box.classList.remove('is-error'); void box.offsetWidth; box.classList.add('is-error'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      check.focus({ preventScroll: true });
      return false;
    }
    function syncSingle() {
      var check = document.querySelector('[data-nx-consent-check]');
      var ctas = document.querySelectorAll('.nx-single__cta');
      if (!check || !ctas.length) return;
      ctas.forEach(function (c) { c.setAttribute('aria-disabled', check.checked ? 'false' : 'true'); });
    }
    function bind() {
      var check = document.querySelector('[data-nx-consent-check]');
      if (check && !check.dataset.nxSingleBound) { check.dataset.nxSingleBound = '1'; check.addEventListener('change', syncSingle); }
      syncSingle();
    }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.nx-single__cta') : null;
      if (!a) return;
      e.preventDefault();
      if (!consentOk(a)) return;
      var stamp = new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
      window.location.href = a.getAttribute('href') + '?attributes[' + encodeURIComponent('Termini e privacy accettati') + ']=' + encodeURIComponent('Accettato il ' + stamp);
    });
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bind); } else { bind(); }
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-perche"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tilt(el) {
    if (el.dataset.tiltReady || window.matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches) return;
    el.dataset.tiltReady = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
      el.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
      el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
      el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
  }
  function init(scope) { (scope || document).querySelectorAll('[data-nx-tilt]').forEach(tilt); if (window.nxReveal) window.nxReveal(scope); }
  if (!window.nxReveal) {
    window.nxReveal = function (scope) {
      var els = (scope || document).querySelectorAll('[data-nx-reveal]:not(.is-in)');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
      els.forEach(function (el) { io.observe(el); });
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-prezzi"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tilt(el) {
    if (el.dataset.tiltReady || window.matchMedia('(hover: none), (prefers-reduced-motion: reduce)').matches) return;
    el.dataset.tiltReady = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg'); el.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
  }
  function init(scope) {
    (scope || document).querySelectorAll('.nx-price').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      root.querySelectorAll('[data-nx-tilt]').forEach(tilt);
      var check = root.querySelector('[data-nx-consent-check]'), err = root.querySelector('[data-nx-consent-error]'), box = root.querySelector('[data-nx-consent]');
      var buys = root.querySelectorAll('[data-nx-buy]');
      function sync() {
        buys.forEach(function (b) { b.setAttribute('aria-disabled', check.checked ? 'false' : 'true'); });
        if (check.checked) { err.hidden = true; box.classList.remove('is-error'); }
      }
      check.addEventListener('change', sync); sync();
      buys.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (!check.checked) {
            err.hidden = false; box.classList.remove('is-error'); void box.offsetWidth; box.classList.add('is-error');
            box.scrollIntoView({ behavior: 'smooth', block: 'center' }); check.focus({ preventScroll: true });
            return;
          }
          var stamp = new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
          var url = b.getAttribute('href') + '?attributes[' + encodeURIComponent('Termini e privacy accettati') + ']=' + encodeURIComponent('Accettato il ' + stamp) + (root.getAttribute('data-promo') ? '&discount=' + encodeURIComponent(root.getAttribute('data-promo')) : '');
          window.location.href = url;
        });
      });
    });
    if (window.nxReveal) window.nxReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
(function () {
  function initBar() {
    var bar = document.querySelector('[data-nx-sbar]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var prices = document.getElementById('prezzi');
    var rc = document.querySelector('[data-nx-rc]');
    var foot = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    var cta = bar.querySelector('[data-nx-sbar-cta]');
    var seen = false, inPrices = false;
    bar.hidden = false;
    function track(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }
    function update() {
      var vh = window.innerHeight;
      var past = rc ? rc.getBoundingClientRect().bottom < 0 : window.pageYOffset > vh * 0.8;
      var on = past && !inPrices;
      if (on && foot && foot.getBoundingClientRect().top < vh) on = false;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('nx-sbar-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      cta.tabIndex = on ? 0 : -1;
      if (on && !seen) { seen = true; track('sticky_view'); }
    }
    if (prices && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inPrices = es[0].isIntersecting; update(); }, { rootMargin: '-35% 0px -35% 0px' }).observe(prices);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      track('sticky_click');
      var card = document.querySelector('.nx-plan--main') || prices;
      if (!card) return;
      var y = card.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
      card.classList.add('is-flash');
      setTimeout(function () { card.classList.remove('is-flash'); }, 1800);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBar); else initBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-problema"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.nxReveal) { window.nxReveal(); return; }
  window.nxReveal = function (scope) {
    var els = (scope || document).querySelectorAll('[data-nx-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.nxReveal(); });
  else window.nxReveal();
  document.addEventListener('shopify:section:load', function (e) { window.nxReveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexum-recensioni"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-nx-rev-more]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var grid = btn.closest('.nx-rev').querySelector('[data-nx-rev-grid]');
        grid.classList.add('is-open');
        grid.querySelectorAll('.nx-rv--more').forEach(function (el) { el.classList.add('is-in'); });
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
      });
    });
    if (window.nxReveal) window.nxReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
